<div class="perfil-visualizar-modal__overlay" (click)="onFechar()">
  <div
    class="perfil-visualizar-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="perfil-visualizar-modal-title"
    data-testid="perfil-visualizar-modal"
    (click)="$event.stopPropagation()"
  >
    <div class="perfil-visualizar-modal__header">
      <div class="perfil-visualizar-modal__title-row">
        <h2
          id="perfil-visualizar-modal-title"
          class="perfil-visualizar-modal__title"
          data-testid="perfil-visualizar-modal-nome"
        >
          {{ perfil().nome }}
        </h2>
        <app-status-badge
          [status]="perfil().status"
          data-testid="perfil-visualizar-modal-status"
        />
      </div>
      <button
        type="button"
        class="perfil-visualizar-modal__close"
        aria-label="Fechar"
        data-testid="perfil-visualizar-modal-close"
        (click)="onFechar()"
      >
        &times;
      </button>
    </div>

    <dl class="perfil-visualizar-modal__fields">
      <div class="perfil-visualizar-modal__field">
        <dt class="perfil-visualizar-modal__label">Nome de exibição</dt>
        <dd class="perfil-visualizar-modal__value" data-testid="perfil-visualizar-modal-nome-exibicao">
          {{ perfil().nomeExibicao || '—' }}
        </dd>
      </div>
      <div class="perfil-visualizar-modal__field">
        <dt class="perfil-visualizar-modal__label">Última atualização</dt>
        <dd class="perfil-visualizar-modal__value" data-testid="perfil-visualizar-modal-atualizacao">
          {{ formatDate(perfil().ultimaAtualizacao) }}
        </dd>
      </div>
      <div class="perfil-visualizar-modal__field perfil-visualizar-modal__field--full">
        <dt class="perfil-visualizar-modal__label">Descrição</dt>
        <dd class="perfil-visualizar-modal__value" data-testid="perfil-visualizar-modal-descricao">
          {{ perfil().descricao || '—' }}
        </dd>
      </div>
    </dl>

    @if (perfil().categorias.length > 0) {
      <ul class="perfil-visualizar-modal__categoria-list">
        @for (categoria of perfil().categorias; track $index) {
          <li
            class="perfil-visualizar-modal__categoria-item"
            data-testid="perfil-visualizar-modal-categoria"
          >
            <span
              class="perfil-visualizar-modal__swatch"
              aria-hidden="true"
              [style.background-color]="categoria.cor"
            ></span>
            <span class="perfil-visualizar-modal__categoria-nome">{{ categoria.nomeCategoria }}</span>
            <span class="perfil-visualizar-modal__categoria-valor">{{ categoria.valorPercentual }}%</span>
          </li>
        }
      </ul>
    }

    <div class="perfil-visualizar-modal__actions">
      <button
        type="button"
        class="perfil-visualizar-modal__btn-secondary perfil-visualizar-modal__btn-secondary--sm"
        data-testid="perfil-visualizar-modal-editar"
        (click)="onEditar()"
      >
        Editar Perfil
      </button>
    </div>
  </div>
</div>